// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill>.ql-container {
    border: solid grey 1px;
}

.ql-bubble .ql-tooltip {
    left: 0% !important;
}

.quill {
    margin: 1rem;
}

.ql-container {
    background: #fefcfc;
    margin-bottom: 0.5%;

}

.quill .ql-bubble.ql-toolbar {
    display: block;
}

.quill>.ql-container>.ql-editor.ql-blank::before {
    font-family: sans-serif;
    font-style: normal;
}

.quill .ql-editor {
    min-height: 4em;
    font-size: 1rem;
    font-style: normal;
}

.quill .ql-formats button {
    position: relative
}
/* 
.quill .ql-formats button:hover:after,
.quill .ql-formats button:active:after,
.quill .ql-formats button:focus:after {
    background: black;
    color: white;
    padding: .2em;
    border-radius: .5em;
    width: max-content;
    font-size: 0.7rem;
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
}

.quill .ql-bold:hover:after,
.quill .ql-bold:active:after,
.quill .ql-bold:focus:after {
    content: 'Bold Ctrl B';
}

.quill .ql-italic:hover:after,
.quill .ql-italic:active:after,
.quill .ql-italic:focus:after {
    content: 'Italic Ctrl I';
}

.quill .ql-underline:hover:after,
.quill .ql-underline:active:after,
.quill .ql-underline:focus:after {
    content: 'Underline Ctrl U';
}

.quill .ql-strike:hover:after,
.quill .ql-strike:active:after,
.quill .ql-strike:focus:after {
    content: 'StrikeThrough';
}

.quill .ql-size:hover:after,
.quill .ql-size:active:after,
.quill .ql-size:focus:after {
    content: 'Size';
}

.quill .ql-script[value="sub"]:hover:after,
.quill .ql-script:active:after,
.quill .ql-script:focus:after {
    content: 'SubScript';
}

.quill .ql-script[value="super"]:hover:after,
.quill .ql-script:active:after,
.quill .ql-script:focus:after {
    content: 'SuperScript';
}

.quill .ql-color:hover:after,
.quill .ql-color:active:after,
.quill .ql-color:focus:after {
    content: 'Color';
} */`, "",{"version":3,"sources":["webpack://./src/ui/pages/container/Label-Studio/cl_ui.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;AACJ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+DG","sourcesContent":[".quill>.ql-container {\n    border: solid grey 1px;\n}\n\n.ql-bubble .ql-tooltip {\n    left: 0% !important;\n}\n\n.quill {\n    margin: 1rem;\n}\n\n.ql-container {\n    background: #fefcfc;\n    margin-bottom: 0.5%;\n\n}\n\n.quill .ql-bubble.ql-toolbar {\n    display: block;\n}\n\n.quill>.ql-container>.ql-editor.ql-blank::before {\n    font-family: sans-serif;\n    font-style: normal;\n}\n\n.quill .ql-editor {\n    min-height: 4em;\n    font-size: 1rem;\n    font-style: normal;\n}\n\n.quill .ql-formats button {\n    position: relative\n}\n/* \n.quill .ql-formats button:hover:after,\n.quill .ql-formats button:active:after,\n.quill .ql-formats button:focus:after {\n    background: black;\n    color: white;\n    padding: .2em;\n    border-radius: .5em;\n    width: max-content;\n    font-size: 0.7rem;\n    position: absolute;\n    z-index: 1;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -60px;\n}\n\n.quill .ql-bold:hover:after,\n.quill .ql-bold:active:after,\n.quill .ql-bold:focus:after {\n    content: 'Bold Ctrl B';\n}\n\n.quill .ql-italic:hover:after,\n.quill .ql-italic:active:after,\n.quill .ql-italic:focus:after {\n    content: 'Italic Ctrl I';\n}\n\n.quill .ql-underline:hover:after,\n.quill .ql-underline:active:after,\n.quill .ql-underline:focus:after {\n    content: 'Underline Ctrl U';\n}\n\n.quill .ql-strike:hover:after,\n.quill .ql-strike:active:after,\n.quill .ql-strike:focus:after {\n    content: 'StrikeThrough';\n}\n\n.quill .ql-size:hover:after,\n.quill .ql-size:active:after,\n.quill .ql-size:focus:after {\n    content: 'Size';\n}\n\n.quill .ql-script[value=\"sub\"]:hover:after,\n.quill .ql-script:active:after,\n.quill .ql-script:focus:after {\n    content: 'SubScript';\n}\n\n.quill .ql-script[value=\"super\"]:hover:after,\n.quill .ql-script:active:after,\n.quill .ql-script:focus:after {\n    content: 'SuperScript';\n}\n\n.quill .ql-color:hover:after,\n.quill .ql-color:active:after,\n.quill .ql-color:focus:after {\n    content: 'Color';\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
